const Employes = [
{
    id:"1",
    Name:"Nagesh Mandal",
    Age:"30"
},{
    id:"2",
    Name:"Rakesh Mandal",
    Age:"32"
},{
    id:"3",
    Name:"Suresh Mandal",
    Age:"28"
}
]

export default Employes;